import React from 'react';
import { FooterContent } from './components/FooterContent';
import styles from './Footer.module.css';

const Footer = () => {
    return (
        <footer className={styles.footer}>
            <section className={styles.footerSection}>
                <div className={styles.backgroundOverlay}>
                    <div className={styles.backgroundWhite}></div>
                    <div className={styles.backgroundContent}></div>
                </div>
                <FooterContent />
            </section>
        </footer>
    );
};

export default Footer;